import { AdditionalEffort, SearchProceduresResult } from 'ts-types/api.types';
import { ExtendedBaseEntryDto } from 'components/segments/entires/EntriesContext';

type ProcedureType = Partial<ExtendedBaseEntryDto> | Partial<SearchProceduresResult>;
type EntryType = ExtendedBaseEntryDto | AdditionalEffort;

export const findEntryPredicate = (entry: EntryType, procedureToCompare: ProcedureType): boolean => {

  if (!!procedureToCompare.code && !!(entry as ExtendedBaseEntryDto).code) {
    return procedureToCompare.code == (entry as ExtendedBaseEntryDto).code;
  }

  return procedureToCompare.description == entry.description;
};
